import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/admin/Dashboard';
import NovoOnboarding from './pages/admin/NovoOnboarding';
import EditarOnboarding from './pages/admin/EditarOnboarding';
import GerenciarModulos from './pages/admin/GerenciarModulos';
import HistoricoOnboarding from './pages/admin/HistoricoOnboarding';
import Portal from './pages/cliente/Portal';

function RotaProtegida({ children, tipoRequerido }) {
  const token = localStorage.getItem('ht_token');
  const usuario = JSON.parse(localStorage.getItem('ht_usuario') || 'null');
  if (!token || !usuario) return <Navigate to="/login" replace />;
  if (tipoRequerido && usuario.tipo !== tipoRequerido) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        {/* Admin */}
        <Route path="/admin" element={<RotaProtegida tipoRequerido="admin"><Dashboard /></RotaProtegida>} />
        <Route path="/admin/novo" element={<RotaProtegida tipoRequerido="admin"><NovoOnboarding /></RotaProtegida>} />
        <Route path="/admin/onboarding/:id" element={<RotaProtegida tipoRequerido="admin"><EditarOnboarding /></RotaProtegida>} />
        <Route path="/admin/onboarding/:id/historico" element={<RotaProtegida tipoRequerido="admin"><HistoricoOnboarding /></RotaProtegida>} />
        <Route path="/admin/modulos" element={<RotaProtegida tipoRequerido="admin"><GerenciarModulos /></RotaProtegida>} />

        {/* Cliente */}
        <Route path="/onboarding/:id" element={<RotaProtegida tipoRequerido="cliente"><Portal /></RotaProtegida>} />

        {/* Redirecionamentos */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
